<div *ngIf="!menuV3" class="flex-wrapper">
  <div class="application-menu-content">
    <div class="menu-search-span">
      <lm-application-menu-search-field
        [menuV3]="menuV3"
        [model]="model"
        [collapsibleOnMobile]="true"
        [testVersion1]="testVersion1"
        (autoSearchMenu)="autoSearchMenu($event)"
        (fireMenuSearchEvent)="fireMenuSearchEvent($event)"
        (fireClearSearchEvent)="fireClearSearchEvent($event)">
      </lm-application-menu-search-field>
      <p *ngIf="limitSearch && !noSearchResults" class="limitedSearch">{{ 'SearchResultLimited' | translate }}</p>
      <p *ngIf="noSearchResults" class="noResultFound" >
        {{ 'NoSearchResultsFound' | translate }}
      </p>

      <div class="accordion panel inverse"
           data-options="{'allowOnePane': 'true', 'rerouteOnLinkClick': 'false'}"
           soho-busyindicator blockUI="true" displayDelay="0">
        <ng-container *ngTemplateOutlet="SearchResults" ></ng-container>
      </div>
    </div>
  </div>
</div>

<ng-container *ngIf="menuV3">
  <ng-container *ngTemplateOutlet="SearchResults"></ng-container>
  <p *ngIf="limitSearch && !noSearchResults" class="limitedSearch">{{ 'SearchResultLimited' | translate }}</p>
  <p *ngIf="noSearchResults" class="noResultFound" >
    {{ 'NoSearchResultsFound' | translate }}
  </p>
</ng-container>

<ng-template #SearchResults>
  <!-- SEARCH MENUITEMS RESULTS SECTIONS -->
  <ng-container *ngFor="let webAppSpec of webAppSpecsWithSearchResults">
    <div #searchMenuHeader
         class="accordion-header"
         id="ApplicationSearchResults_{{webAppSpec.webAppName}}"
    >
      <svg soho-icon icon="roles"></svg>
      <a href="#"
         attr.data-automation-id="lm-{{webAppSpec.webAppName}}-searchresults"
         id="{{webAppSpec.webAppName}}SearchResults"
      >
        <span>{{webAppSpec.webAppTitle}}</span>
      </a>
    </div>

    <div *ngIf="menuSearchResultsByWebApp [ webAppSpec.webAppName ].length > 0" class="accordion-pane">
      <ng-container *ngFor="let menuSearchResult of menuSearchResultsByWebApp [ webAppSpec.webAppName ]">
        <div *ngIf="menuSearchResult.menu" #accordionHeader class="accordion-header">
          <button class="btn" type="button">
            <span class="icon plus-minus" aria-hidden="true" role="presentation"></span>
          </button>
          <a href="#"
             attr.data-automation-id="{{dataAutomationId(menuSearchResult)}}"
             attr.id="{{menuSearchResult.id}}_searchresult"
             (click)="onMenuItemClicked(menuSearchResult)"
          >
            <span class="accordion-search-span-heading">{{menuSearchResult.child}}</span>
            <ng-container *ngIf="menuSearchResult.parent">
              <br>
              <span class="accordion-search-span-subheading">{{menuSearchResult.parent}}</span>
            </ng-container>
          </a>
        </div>
        <lm-application-menu-submenu
                *ngIf="menuSearchResult.menu"
                class="accordion-pane has-icons"
                [inSearchResultsMenu]="true"
                [menuItemSpecs]="menuSearchResult?.menu"
                (menuLoaded)="onMenuLoaded($event)"
        ></lm-application-menu-submenu>
      </ng-container>

      <ng-container *ngFor="let menuSearchResult of menuSearchResultsByWebApp [ webAppSpec.webAppName ]">
        <div *ngIf="!menuSearchResult.menu" class="accordion-header">
          <a href="#"
             attr.data-automation-id="{{dataAutomationId(menuSearchResult)}}"
             attr.id="{{menuSearchResult.id}}_searchresult"
             attr.searchMenuUrl="{{menuSearchResult.url}}"
             (click)="openSearchMenuItem($event)"
          >
            <span class="accordion-search-span-heading">{{menuSearchResult.child}}</span>
            <ng-container *ngIf="menuSearchResult.parent">
              <br>
              <span class="accordion-search-span-subheading">{{menuSearchResult.parent}}</span>
            </ng-container>
          </a>
        </div>
      </ng-container>
    </div>
  </ng-container>

  <!-- SYSTEM RESULTS SECTIONS -->
  <div *ngIf="systemSearchResults.length > 0" #searchMenuHeader class="accordion-header">
    <svg soho-icon icon="bullet-list"></svg>
    <a href="#" id="SystemSearchResults" data-automation-id="lm-System-searchresults"><span>{{systemTitle}}</span></a>
  </div>
  <div *ngIf="systemSearchResults.length > 0" class="accordion-pane">
    <ng-container *ngFor="let systemSearchResult of systemSearchResults">
      <div class="accordion-header">
        <a href="#"
           attr.data-automation-id="lm-System-{{systemSearchResult.automationId}}-searchresult"
           attr.id="System_{{systemSearchResult.id}}_searchresult"
           attr.searchMenuUrl="{{systemSearchResult.url}}"
           (click)="systemMenuItemClick(systemSearchResult)"
        >
          <span class="accordion-search-span-heading">{{systemSearchResult.child}}</span><br>
        </a>
      </div>
    </ng-container>
  </div>

  <!-- SEARCH REPORTS RESULTS SECTIONS -->
  <div *ngIf="reportSearchResults.length > 0" #searchMenuHeader class="accordion-header">
    <svg soho-icon icon="bar"></svg>
    <a href="#" id="ReportsSearchResults" data-automation-id="lm-Reports-searchresults"><span>{{reportTitle}}</span></a>
  </div>
  <div *ngIf="reportSearchResults.length > 0" class="accordion-pane">
    <ng-container *ngFor="let reportSearchResult of reportSearchResults">
      <div class="accordion-header">
        <a href="#"
           attr.data-automation-id="lm-Report-{{reportSearchResult.automationId}}-searchresult"
           attr.id="Report_{{reportSearchResult.id}}_searchresult"
           attr.searchMenuUrl="{{reportSearchResult.url}}"
           (click)="openSearchItemLink($event)"
        >
          <span class="accordion-search-span-heading">{{reportSearchResult.child}}</span><br>
          <span class="accordion-search-span-subheading">{{reportSearchResult.parent}}</span>
        </a>
      </div>
    </ng-container>
  </div>

  <!-- SEARCH DATA RESULTS SECTIONS -->
  <div *ngIf="dataSearchResults.length > 0"  #searchMenuHeader class="accordion-header">
    <svg soho-icon icon="folder"></svg>
    <a href="#" id="DataSearchResults" data-automation-id="lm-Data-searchresults"><span>{{dataTitle}}</span></a>
  </div>
  <div *ngIf="dataSearchResults.length > 0" class="accordion-pane">
    <ng-container *ngFor="let dataSearchResult of dataSearchResults">
      <div class="accordion-header">
        <a href="#"
           attr.data-automation-id="{{dataAutomationId(dataSearchResult)}}"
           attr.id="{{dataSearchResult.id}}_searchresult"
           attr.resourceId="{{dataSearchResult.resourceId}}"
           attr.searchMenuUrl="{{dataSearchResult.url}}"
           (click)="openSearchItemLink($event)"
        >
          <span class="accordion-search-span-heading">{{dataSearchResult.child}}</span><br>
          <span class="accordion-search-span-subheading">{{dataSearchResult.parent}}</span>
        </a>
      </div>
    </ng-container>
  </div>
</ng-template>

<div #menuFormDialog>
  <!-- dialog placeholder used to display action form from menu -->
</div>

<!--Accessibility: ARIA live region-->
<div class="audible" aria-hidden="true" aria-live="polite">
  {{ accessibility.announcement }}
</div>
